import { Col, Layout, Row } from 'antd';
import React from 'react';
import { Navigate } from 'react-router-dom';

import './load.scss';

class ControllerPageLoad extends React.Component {
  state = {
    _navigate: false,
  };

  onButton = () => {
    this.setState({ _navigate: true });
  };

  render = () => {
    const { Content } = Layout;

    if (this.state._navigate) {
      return <Navigate to="/" />;
    }

    return (
      <Content>
        <Row justify="center" style={{ height: '80vh', alignItems: 'center' }}>
          <Col span={24}>
            <div className="loader-container">
              <div className="loader">
                <div />
                <div />
              </div>
            </div>
          </Col>
        </Row>
      </Content>
    );
  };
}

export default ControllerPageLoad;
